import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ModalBasic from "./ModalBasic.jsx";
import { PrimaryButton } from "./Buttons.jsx";
import { dismissAnnouncement, getPendingAnnouncements } from "../api/announcements.js";

const AnnouncementModal = () => {
  const user = useSelector((state) => state.app.user);
  const [items, setItems] = useState([]);
  const [dismissing, setDismissing] = useState(false);
  const [error, setError] = useState("");
  const dismissingRef = useRef(false);

  useEffect(() => {
    if (!user?.id || user.type === "prospect") return undefined;
    let cancelled = false;
    (async () => {
      try {
        const result = await getPendingAnnouncements();
        if (!cancelled) {
          setItems(Array.isArray(result?.data) ? result.data : []);
        }
      } catch (err) {
        if (!cancelled) {
          setItems([]);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user?.id, user?.type]);

  const current = items[0];

  const close = async () => {
    if (!current || dismissingRef.current) return;
    dismissingRef.current = true;
    setDismissing(true);
    setError("");
    try {
      await dismissAnnouncement(current.id);
      setItems((prev) => prev.slice(1));
    } catch (err) {
      setError("Couldn't save that you closed this. Try again.");
    } finally {
      dismissingRef.current = false;
      setDismissing(false);
    }
  };

  if (!current) return null;

  return (
    <ModalBasic
      id="announcement-modal"
      modalOpen
      setModalOpen={(open) => {
        if (!open) close();
      }}
      title={current.title || "Announcement"}
      width="2xl"
      zIndex={80}
    >
      <div
        className="text-sm text-slate-600 dark:text-slate-300 [&_a]:text-indigo-500 [&_a]:underline [&_h1]:mb-2 [&_h1]:text-lg [&_h1]:font-semibold [&_h1]:text-slate-800 dark:[&_h1]:text-slate-100 [&_h2]:mb-2 [&_h2]:text-base [&_h2]:font-semibold [&_h2]:text-slate-800 dark:[&_h2]:text-slate-100 [&_img]:my-3 [&_img]:max-w-full [&_ol]:mb-3 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:mb-3 [&_ul]:mb-3 [&_ul]:list-disc [&_ul]:pl-5"
        dangerouslySetInnerHTML={{ __html: current.html }}
      />
      {error && (
        <p className="mb-3 text-sm text-rose-500">{error}</p>
      )}
      <div className="flex justify-end">
        <PrimaryButton type="button" onClick={close} loading={dismissing}>
          Got it
        </PrimaryButton>
      </div>
    </ModalBasic>
  );
};

export default AnnouncementModal;
